export const GET_SOURCE_STATISTIC_REQUEST = 'GET_SOURCE_STATISTIC_REQUEST';
export const GET_SOURCE_STATISTIC_SUCCESS = 'GET_SOURCE_STATISTIC_SUCCESS';
export const GET_SOURCE_STATISTIC_ERROR = 'GET_SOURCE_STATISTIC_ERROR';
export const GET_RESERVES_BY_SOURCE_REQUEST = 'GET_RESERVES_BY_SOURCE_REQUEST';
export const GET_RESERVES_BY_SOURCE_SUCCESS = 'GET_RESERVES_BY_SOURCE_SUCCESS';
export const GET_RESERVES_BY_SOURCE_ERROR = 'GET_RESERVES_BY_SOURCE_ERROR';
export const GET_SOURCE_INFO_REQUEST = 'GET_SOURCE_INFO_REQUEST';
export const GET_SOURCE_INFO_SUCCESS = 'GET_SOURCE_INFO_SUCCESS';
export const GET_SOURCE_INFO_ERROR = 'GET_SOURCE_INFO_ERROR';
